import * as React from "react";
//import { useSelector } from "react-redux";
import {
  Frame,
  Container,
  Footer,
  LogoView,
  BrandModel,
  Nav,
  OTRS,
  Accessibility,
} from "../frame/index.js";
import * as cls from "./ProductFrame.module.scss";
export { ProductFrame };
/**
 * Фрейм страницы учебного продукта, включающий панель навигации,
 * обрамление основного содержимого и подвал с юридической информацией.
 * @summary Фрейм учебного продукта.
 * @param {Object} props - Атрибуты элемента.
 * @param {string} props.title - Заголовок окна.
 * @param {BrandModel} props.brand - Бренд (логотип, footer).
 * @param {Action[]} [props.menu] -
 * Дополнительные пункты меню.
 * @param {JSX.Element} props.children -
 * Основное содержимое страницы.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * import {ProductFrame, Section, TextCard, Text, Icon, OTRS}
 *	from "../personal-studio-components/product/index.js";
 * <ProductFrame title="Устный экзамен">Содержимое</ProductFrame>
 * @see {@link ../frame/Action.jsx}, {@link ../frame/Logo.jsx}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ProductFrame({
  title = "ProductFrame.title",
  vuz_id = 0,
  menu = [],
  isLecture,
  children,
  isMobile,
}) {
  const brand = new BrandModel({});
  brand.setLogo(vuz_id);
  const frameNav = [...menu, OTRS.OPEN, Accessibility.OPEN];
  return (
    <Frame title={title}>
      <Container
        tagName="nav"
        isLecture={isLecture}
        className={cls.product_navbar}
        isMobile={isMobile}
      >
        <LogoView brand={brand} />
        <Nav menu={frameNav} />
      </Container>
      <Container tagName="nav" isLecture={isLecture} isMobile={isMobile}>
        <Accessibility />
      </Container>
      <Container
        isLecture={isLecture}
        tagName="main"
        className={cls.product_main}
        isMobile={isMobile}
      >
        <h1>{title}</h1>
        {children && (
          <div className={isLecture && isMobile ? "" : cls.product_body}>
            {children}
          </div>
        )}
      </Container>
      <Footer vuz_id={vuz_id} />
    </Frame>
  );
}
